'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('suite-directory', {
      url: '/suite/directory/:type',
      template: '<suite-directory></suite-directory>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/suite/suite-directory.routes.js